'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeInRightBig = {
  from: {
    opacity: 0,
    transform: (0, _utils.translate3d)('2000px', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInRightBig;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/fade-in-right-big.js
// module id = 2119
// module chunks = 0